import { createContext, useContext, useState, useEffect } from 'react';
import axiosInstance from '../api/axiosInstance';

const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);

  const loadUnreadCount = async () => {
    try {
      const res = await axiosInstance.get('/pm-conversations/unread-count');
      setUnreadCount(res.data.count);
    } catch (err) {
      console.error('Fehler beim Laden der ungelesenen Nachrichten', err);
    }
  };

  useEffect(() => {
    loadUnreadCount(); // beim Laden

    const interval = setInterval(() => {
      loadUnreadCount();
    }, 60000); // ⏱ alle 60 Sekunden

    return () => clearInterval(interval); // Cleanup beim Unmount
  }, []);

  return (
    <MessageContext.Provider value={{ unreadCount, setUnreadCount, loadUnreadCount }}>
      {children}
    </MessageContext.Provider>
  );
};

export const useMessage = () => useContext(MessageContext);
